__turbopack_context__.v({
  "Bold": "hcgt_q_Bold",
  "LineItem": "hcgt_q_LineItem",
  "PlaceThird": "hcgt_q_PlaceThird",
  "Price": "hcgt_q_Price",
  "Quantity": "hcgt_q_Quantity",
  "SubTitle": "hcgt_q_SubTitle",
  "SuperTitle": "hcgt_q_SuperTitle",
  "Title": "hcgt_q_Title",
});
